<div class="grid--container" [ngClass]="columns">
  @if (columns !== 'col-12') {
    <div class="grid--section-left">
      <ng-content select="[left]"></ng-content>
    </div>
    <div class="grid--section-right">
      <ng-content select="[right]"></ng-content>
    </div>
  } @else {
    <ng-content></ng-content>
  }
</div>
